<template>
    <div class="wine-club-steps">
        <Step1 v-if="getConfigStep === 0" :memberships="settings.Memberships" />
        <Step2 v-if="getConfigStep === 1" />
        <Step3 v-if="getConfigStep === 2" />
        <Step4 v-if="getConfigStep === 3" />
        <Step5 v-if="getConfigStep === 4" :member="settings.MemberData" />
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
import Step3 from "./Step3.vue";
import Step4 from "./Step4.vue";
import Step5 from "./Step5.vue";
export default {
    name: "ShipmentBuilder",
    props: {
        settings: {
            type: Object,
        },
    },
    components: {
        Step1,
        Step2,
        Step3,
        Step4,
        Step5,
    },
    mounted() {
        this.setDefaults();
        // This is a helper so in the browser console we can call setConfigStep(n) just to move around a little easier
        window.setConfigStep = this.setConfigStep;

        this.goToCorrectStep()
    },
    computed: {
        ...mapGetters([
            "getConfigStep",
            "getShipmentWines",
            "getNextShipmentDate",
            "getExistingPreference",
            "getAvailableShipments",
            "getActiveCatalog",
            "getShipmentCountry",
        ]),
    },
    methods: {
        ...mapActions([
            "initialiseClubs",
            "initialiseMember",
            "changeCountry",
            "setConfigStep",
            "setActiveCatalog",
            "setShippingWineList",
        ]),
        setDefaults() {
            if (this.settings.ClubData) {
                this.initialiseClubs(this.settings.ClubData);
            }
            if (this.settings.MemberData && this.settings.MemberData.MemberID) {
                this.initialiseMember(this.settings.MemberData);
            } else {
                this.changeCountry("NZ");
            }

            const country = this.settings.MemberData.MemberCountry ?? this.getShipmentCountry;

            this.settings.Memberships.map((membership) => {
                const { ClubData } = this.settings

                if (ClubData[country] && ClubData[country].Discounts) {
                    const membershipDiscount = this.settings.ClubData[
                        country
                    ].Discounts.find((discount) => {
                        return discount.MemberTier.ID === membership.ID;
                    });
                    if (membershipDiscount) {
                        membership.Discount = membershipDiscount;
                    }
                }
                return membership;
            });

            // Set the active catalog
            if (this.settings.MemberData.Preference && this.settings.MemberData.Preference.Catalog) {
                if (this.settings.MemberData.Preference.Catalog.WineCount === 0 && this.settings.MemberData.Preference.Wines.length) {
                    // If the order is custom
                    this.setShippingWineList(this.settings.MemberData.Preference.Wines)
                } else {
                    this.setActiveCatalog(this.settings.MemberData.Preference.Catalog)
                }
            }

        },
        goToCorrectStep() {
            // Check GET params if we have been redirected from billing
            // if we have show the confirm screen
            // Check if the URL contains the "?confirm" parameter
            if (window.location.search.includes('?confirm')) {
                // Get the current URL without the query parameters
                const newUrl = window.location.origin + window.location.pathname;
                // Use history.replaceState to update the URL without reloading the page
                window.history.replaceState({}, document.title, newUrl);
                this.setConfigStep(3)
            } else {

                // Make sure we have an activeCatalog or custom shipment
                // Make sure the shipment wines have an ID ( user has selected some wine )
                if (this.getActiveCatalog || this.getShipmentWines && this.getShipmentWines[0].ID) {
                    this.setConfigStep(4);
                }
            }
        }
    },
};
</script>
